import { combineReducers } from 'redux';
import { createSelectorHook } from 'react-redux';
import ableReducer from './ableReducer';
import demoReducer from './demoReducer';
import fetchReducer from './fetch';
import cashierReducer from './Cashier/cashierReducer';
import loginReducer from './Auth/authReducer';
import { selectClinicReducer } from './SelectClinic/SelectClinicReducer';
// import { caslReducer } from './Casl/caslReducer';
import modalReducer from './ModalAppoinment/modalReducer';
import imrReducer from './Imr/imrReducer';
import attendanceReducer from './Attendance/attendanceReducer';
import resetPasswordReducer from './ResetPassword/resetPasswordReducer';
const reducer = combineReducers({
  able: ableReducer,
  demo: demoReducer,
  fetch: fetchReducer,
  auth: loginReducer,
  cashier: cashierReducer,
  imr: imrReducer,
  // casl: caslReducer,
  appointment: modalReducer,
  select: selectClinicReducer,
  attendance: attendanceReducer,
  resetPassword: resetPasswordReducer,
});
export const useSelector = createSelectorHook();
export default reducer;
